import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const LoginAPI = (formData) => API.post('admin/login', formData);

export const LogOutAPI = (token) => {
    try {
        return API.post('admin/logout', {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    } catch (error) {
        console.log(error);
        
        if (error.response) {
            console.log("Error Status Code:", error.response.status);
        }
    }
};
